/** 来源：crm/foodbuy Textarea；保留原生属性透传，默认三行并支持 ref。 */
import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { controlClassName } from './control-classes'

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { error?: boolean }

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className = '', rows = 3, error = false, ...props },
  ref
) {
  return <textarea ref={ref} className={`${controlClassName(className, error)} min-h-20 resize-y leading-6`} rows={rows} aria-invalid={error || undefined} {...props} />
})
